import { observer } from 'mobx-react-lite'
import { useEffect, useState } from 'react'
import { makeTextFieldIcon } from 'shared/ui/TextField'
import { SendFromMulti } from 'widgets/SendFromMulti'
import {
  type IInboxSlackMapping,
  type IntegrationSlackSettingsStore,
} from 'pages/settings/pages/integrations/pages/integrationSettings/IntegrationSlackSettings/store/IntegrationSlackSettingsStore'
import styles from './styles.module.scss'

type ISelectInboxesProps = {
  onSelectInboxes: (inboxIds: number[]) => void
  store: IntegrationSlackSettingsStore
  currentMapping: IInboxSlackMapping
}

export const SelectInboxes = observer(
  ({ onSelectInboxes, store, currentMapping }: ISelectInboxesProps) => {
    const { inboxes: selectedInboxIds, error, sendFromMultiStore } = currentMapping
    const [hasChanges, setHasChanges] = useState(false)
    const [originalInboxIds, setOriginalInboxIds] = useState(selectedInboxIds)

    useEffect(() => {
      if (sendFromMultiStore) {
        sendFromMultiStore.setOnSelectionChange((selectedIds) => {
          onSelectInboxes(selectedIds)
          setHasChanges(true)
          store.updateLocalMapping(currentMapping)
        })
      }
    }, [sendFromMultiStore, currentMapping, onSelectInboxes, store])

    return (
      <div className={styles.selectInboxesWrap}>
        <SendFromMulti
          store={sendFromMultiStore}
          textFieldPlaceholderProps={{
            size: 'medium',
            variant: 'stroke',
            className: styles.selectInboxesDropdown,
          }}
          rightActions={[makeTextFieldIcon({ icon: 'chevronDown' })]}
          triggerProps={{
            emptyPlaceholder: 'Select a Salesmsg inbox...',
            selectedOptionsCount: 1,
            isShowIcon: false,
            shouldShowSelectedItems: false,
            showNumbersCount: true,
          }}
          width={310}
          scrollBarMaxHeight={130}
          dropdownProps={{
            placeholder: 'Search inbox',
            propsDropdownList: {
              autoHeightMax: 224,
            },
            onChangeOpen: (isOpen) => {
              if (isOpen) {
                setOriginalInboxIds(selectedInboxIds)
              }
              if (!isOpen && hasChanges) {
                const currentInboxIds = sendFromMultiStore?.selectedInboxIds || []
                const hasRealChanges =
                  JSON.stringify(currentInboxIds) !== JSON.stringify(originalInboxIds)

                if (hasRealChanges) {
                  store.updateMapping(currentMapping, {})
                }
                setHasChanges(false)
              }
            },
          }}
          dropdownGroupProps={{
            showSelectAllButton: true,
            dropdownItemsByGroup: sendFromMultiStore.dropdownItemsByGroup,
            showGroupHeader: true,
            isMultiSelect: true,
            stylesWrap: {
              padding: '6px 4px 8px',
            },
          }}
          popperProps={{
            offset: [0, -42],
          }}
          error={error ? { message: error, placement: 'top' } : undefined}
        />
      </div>
    )
  }
)
